import { createRoute, AnyRoute, Outlet } from '@tanstack/react-router';

import { createRoutesFromConfig, RouteConfig } from './routeHelpers';

import AdminCoupons from '@screens/admin/AdminCoupons';
import AdminUsers from '@screens/admin/AdminUsers';
import AdminAgreements from '@screens/admin/AdminAgreements';
import AdminSupportAccess from '@screens/admin/AdminSupportAccess';
import ObjectiveEdit from '@screens/objectives/ObjectiveEdit';
import ObjectiveCreate from '@screens/objectives/ObjectiveCreate';
import LessonCreate from '@screens/lessons/LessonCreate';
import CourseCreate from '@screens/courses/CourseCreate';
import CourseEdit from '@screens/courses/CourseEdit';
import DegreeEdit from '@screens/degrees/DegreeEdit';
import DegreeCreate from '@screens/degrees/DegreeCreate';
import NewlaneTutorialsCreate from '@screens/newlane-tutorials/NewlaneTutorialsCreate';
import NewlaneTutorialsEdit from '@screens/newlane-tutorials/NewlaneTutorialsEdit';
import AnnouncementsScreen from '@screens/announcements/AnnouncementsScreen';
import { VideoCallRecordingsPage } from '@screens/videoCallRecordings/VideoCallRecordingsPage';
import ObjectiveMediaReview from '@screens/objectives/ObjectiveMediaReview';
import { ProtectedRoute } from '@new/casl/components/ProtectedRoute';

const adminChildConfigs: RouteConfig[] = [
  { path: 'objectives/$objectiveId/edit', component: ObjectiveEdit },
  { path: 'new-objective', component: ObjectiveCreate },
  { path: 'new-lesson', component: LessonCreate },
  { path: 'new-course', component: CourseCreate },
  { path: 'admin/coupons', component: AdminCoupons },
  { path: 'admin/users', component: AdminUsers },
  { path: 'admin/support-access', component: AdminSupportAccess },
  { path: 'admin/agreements', component: AdminAgreements },
  { path: 'create-newlane-tutorials', component: NewlaneTutorialsCreate },
  { path: 'courses/$courseId/edit', component: CourseEdit },
  { path: 'degrees/$id/edit', component: DegreeEdit },
  { path: 'new-degree', component: DegreeCreate },
  { path: 'objective-media-review', component: ObjectiveMediaReview },
  { path: 'newlane-tutorials/$id/edit', component: NewlaneTutorialsEdit },
  { path: 'announcements', component: AnnouncementsScreen },
  { path: 'admin/video-call-recordings', component: VideoCallRecordingsPage },
];

export function createAdminRouteTree(parent: AnyRoute) {
  const adminRoute = createRoute({
    getParentRoute: () => parent,
    id: 'admin',
    component: () => (
      <ProtectedRoute action="access" subject="AdminPanel">
        <Outlet />
      </ProtectedRoute>
    ),
  });
  const adminChildren = createRoutesFromConfig(adminRoute, adminChildConfigs);

  adminRoute.addChildren(adminChildren);

  return adminRoute;
}
